export const heroStats = [
  { label: '收录档案', value: '1,286' },
  { label: '今日新增', value: '37' },
  { label: '参与讨论', value: '9,842' },
];

export const heroTicker = [
  '深夜悄悄改版事件 · 老用户集体不满',
  '付费墙上线 100 天 · 内容质量争议',
  '删帖门 · 三条高热帖同日消失',
  '审核双标质疑 · 社区规则被指两套标准',
  '搬运指控 · 原作者称从未授权',
  '数据泄露传闻 · 官方至今未回应',
];

export const hotRanking = [
  {
    rank: 1,
    title: '深夜悄悄改版事件',
    category: '翻车合集',
    summary:
      '一次没有预告的深夜改版，把沿用多年的板块顺序彻底打乱，老用户第二天打开页面直呼"走错门"。',
    heat: 96,
    stat: '2.4 万条讨论',
  },
  {
    rank: 2,
    title: '付费墙上线后的内容落差',
    category: '负面新闻',
    summary: '收费通道上线后，被指更新节奏变慢、深度内容缩水，付费用户维权帖集中出现。',
    heat: 89,
    stat: '1.7 万条讨论',
  },
  {
    rank: 3,
    title: '删帖门：高热帖集体消失',
    category: '争议事件',
    summary: '三条热度最高的争议帖在流量顶点被清空，站方仅回复"技术维护"，解释未被接受。',
    heat: 85,
    stat: '1.3 万条讨论',
  },
  {
    rank: 4,
    title: '审核标准的"两套尺子"',
    category: '槽点汇总',
    summary: '同类内容一批通过、一批驳回，社区自制的对照表被反复转发。',
    heat: 74,
    stat: '9,600 条讨论',
  },
  {
    rank: 5,
    title: '广告位上的擦边画面',
    category: '负面新闻',
    summary: '首页广告位出现与站点调性不符的内容，引来大量"掉价"评价。',
    heat: 68,
    stat: '7,200 条讨论',
  },
  {
    rank: 6,
    title: '从未回应的搬运指控',
    category: '黑历史',
    summary: '多位原作者列出对比图，指出早期内容大量搬运，官方账号保持沉默。',
    heat: 61,
    stat: '5,400 条讨论',
  },
];

export const feedItems = [
  {
    id: 'feed-01',
    category: '翻车合集',
    title: '改版当天的 24 小时',
    excerpt:
      '从凌晨两点页面突变，到当天中午道歉公告，我们把这一天的用户反应整理成了一条完整的时间切片。',
    author: '档案组 · 阿梧',
    readTime: '8 分钟',
    date: '2025.08.21',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20blurred%20maroon%20light%20streaks%20and%20scattered%20gold%20dust%20particles%2C%20film%20grain%20texture%2C%20geometric%20layered%20shapes%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20dramatic%20moody%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=840&height=560&seq=hl-feed-01&orientation=landscape',
  },
  {
    id: 'feed-02',
    category: '负面新闻',
    title: '付费墙上线百日观察',
    excerpt:
      '一百天里，付费专区更新了几篇、读者满意度如何、退订理由集中在哪几个词上，图上都标清楚了。',
    author: '档案组 · 林崽',
    readTime: '10 分钟',
    date: '2025.08.14',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20folded%20cardboard%20facets%20and%20dusty%20rose%20gradient%20washes%2C%20film%20grain%20texture%2C%20layered%20geometric%20paper%20shapes%2C%20warm%20amber%20accents%20on%20charcoal%20background%2C%20moody%20dramatic%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=840&height=560&seq=hl-feed-02&orientation=landscape',
  },
  {
    id: 'feed-03',
    category: '争议事件',
    title: '删帖门全程梳理',
    excerpt: '三条帖子的发布时间、热度曲线与下架时刻被并列放在一起，巧合与否留给读者判断。',
    author: '档案组 · 阿梧',
    readTime: '12 分钟',
    date: '2025.07.30',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20cracked%20glass%20texture%20and%20amber%20glow%20fragments%2C%20film%20grain%2C%20sharp%20geometric%20shards%20over%20a%20dark%20burgundy%20field%2C%20deep%20crimson%20and%20gold%20palette%2C%20dramatic%20side%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=840&height=560&seq=hl-feed-03&orientation=landscape',
  },
  {
    id: 'feed-04',
    category: '槽点汇总',
    title: '审核标准对照表',
    excerpt: '同样题材的两条内容，一条通过一条退回。对照表做成了一张可以被反复转发的图。',
    author: '档案组 · 南栀',
    readTime: '6 分钟',
    date: '2025.07.18',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20stacked%20vintage%20paper%20strips%20and%20faded%20plum%20shadows%2C%20film%20grain%20texture%2C%20grid%20of%20layered%20rectangles%2C%20warm%20gold%20edges%20over%20charcoal%20tones%2C%20moody%20dramatic%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=840&height=560&seq=hl-feed-04&orientation=landscape',
  },
  {
    id: 'feed-05',
    category: '负面新闻',
    title: '广告位上的那些画面',
    excerpt: '首页广告位一周内的素材变化被逐帧记录下来，争议素材出现的时间点也被标注。',
    author: '档案组 · 林崽',
    readTime: '7 分钟',
    date: '2025.06.29',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20smoky%20charcoal%20clouds%20and%20a%20thin%20gold%20line%20grid%2C%20film%20grain%20texture%2C%20geometric%20overlapping%20planes%2C%20deep%20crimson%20glow%20in%20the%20distance%2C%20dramatic%20moody%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=840&height=560&seq=hl-feed-05&orientation=landscape',
  },
  {
    id: 'feed-06',
    category: '黑历史',
    title: '一场没有回应的搬运指控',
    excerpt: '原作者列出了十余组对比截图，站点至今没有给出正式说明，档案保留原始链接。',
    author: '档案组 · 南栀',
    readTime: '9 分钟',
    date: '2025.06.05',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20crushed%20velvet%20textures%20and%20deep%20burgundy%20stains%2C%20film%20grain%2C%20soft%20geometric%20folds%20in%20warm%20gold%20light%2C%20charcoal%20shadows%2C%20dramatic%20moody%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=840&height=560&seq=hl-feed-06&orientation=landscape',
  },
];

export const timelineEvents = [
  {
    year: '2021',
    title: '起步期的搬运争议',
    desc: '站点早期内容被多位作者指出与其原文高度相似，第一次小范围质疑出现。',
    tone: 'secondary',
  },
  {
    year: '2022',
    title: '首次大规模删帖',
    desc: '一批讨论站内规则的帖子被集中清空，社区第一次出现"删帖门"这一说法。',
    tone: 'primary',
  },
  {
    year: '2023',
    title: '深夜改版风波',
    desc: '无预告改版导致板块顺序整体重排，次日出现大量"还我旧版"的讨论串。',
    tone: 'primary',
  },
  {
    year: '2023',
    title: '数据泄露传闻',
    desc: '有用户称收到非站内来源的消息，官方未作说明，传闻逐渐演变为长期槽点。',
    tone: 'secondary',
  },
  {
    year: '2024',
    title: '付费墙翻车',
    desc: '付费专区上线后更新节奏放缓，退订理由被整理成榜单，长期占据热度前列。',
    tone: 'accent',
  },
  {
    year: '2025',
    title: '审核双标质疑',
    desc: '同类内容处理结果不一致，社区自制对照表被反复转发，成为最新的核心争议。',
    tone: 'accent',
  },
];

export const discussionPosts = [
  {
    id: 'd1',
    name: '老读者·阿越',
    initial: '越',
    time: '3 小时前',
    content:
      '翻车合集那篇整理得挺全的，改版那天我真的以为进错站了，希望后面别再这么搞。',
    likes: 428,
    replies: 36,
    tag: '改版风波',
  },
  {
    id: 'd2',
    name: '路过群众',
    initial: '路',
    time: '5 小时前',
    content:
      '负面新闻里那条广告位的事我截图存过，当时还以为是自己看错了，原来不止我一个人。',
    likes: 311,
    replies: 22,
    tag: '广告争议',
  },
  {
    id: 'd3',
    name: '档案整理员',
    initial: '档',
    time: '昨天',
    content:
      '槽点汇总这部分建议再补一条：站内规则更新从来不通知，全靠自己发现。',
    likes: 596,
    replies: 74,
    tag: '社区规则',
  },
  {
    id: 'd4',
    name: '半糖不加冰',
    initial: '半',
    time: '昨天',
    content:
      '塌房记录的时间线做得不错，但 2023 年那两条其实可以并成一条讲，因果关系更清楚。',
    likes: 187,
    replies: 15,
    tag: '时间线',
  },
];

export const pressQuotes = [
  {
    id: 'p1',
    source: '社区观察笔记',
    date: '2025.08.22',
    quote: '一次改版把积累多年的使用习惯推倒重来，这在内容社区里并不常见。',
  },
  {
    id: 'p2',
    source: '读者来信合集',
    date: '2025.08.06',
    quote: '付费之后最直观的感受不是内容变多，而是等待变长，这大概是很多人离开的原因。',
  },
  {
    id: 'p3',
    source: '内容行业周记',
    date: '2025.07.15',
    quote: '当审核标准无法被外部理解时，任何一次驳回都会被解读成立场问题。',
  },
  {
    id: 'p4',
    source: '搬运观察小组',
    date: '2025.06.09',
    quote: '原作者们要的从来不是赔偿，只是一句署名或者一句说明。',
  },
];

export const tagSummary = [
  { name: '改版风波', count: 218, size: 'lg' },
  { name: '删帖门', count: 176, size: 'lg' },
  { name: '付费墙', count: 154, size: 'md' },
  { name: '审核双标', count: 143, size: 'md' },
  { name: '广告争议', count: 97, size: 'md' },
  { name: '搬运指控', count: 88, size: 'sm' },
  { name: '数据传闻', count: 76, size: 'sm' },
  { name: '规则朝令夕改', count: 64, size: 'sm' },
  { name: '客服失联', count: 52, size: 'sm' },
  { name: '体验倒退', count: 47, size: 'sm' },
  { name: '更新变慢', count: 41, size: 'sm' },
  { name: '界面难用', count: 33, size: 'sm' },
];

export const navLinks = [
  { label: '热度榜单', href: '#ranking' },
  { label: '翻车合集', href: '#feed' },
  { label: '塌房记录', href: '#timeline' },
  { label: '争议事件', href: '#discussion' },
  { label: '槽点汇总', href: '#tags' },
];

export const footerColumns = [
  {
    title: '档案分区',
    links: [
      { label: '热度榜单', href: '#ranking' },
      { label: '翻车合集', href: '#feed' },
      { label: '塌房记录', href: '#timeline' },
      { label: '槽点汇总', href: '#tags' },
    ],
  },
  {
    title: '内容单元',
    links: [
      { label: '黑历史', href: '#timeline' },
      { label: '负面新闻', href: '#press' },
      { label: '争议事件', href: '#discussion' },
      { label: '封面合集', href: '#feed' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '整理原则', href: '#tags' },
      { label: '收录说明', href: '#ranking' },
      { label: '内容更正', href: '#discussion' },
      { label: '来源标注', href: '#press' },
    ],
  },
];